import { render, staticRenderFns } from "./applyTableInfo.vue?vue&type=template&id=593da608&"
import script from "./applyTableInfo.vue?vue&type=script&lang=js&"
export * from "./applyTableInfo.vue?vue&type=script&lang=js&"
import style0 from "./applyTableInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
